const adminSettingsTutorial = {
  module: 'admin_settings',
  moduleName: 'Site Settings',
  steps: [
    { target: '.page-title', position: 'bottom', title: 'Site Settings', description: 'Configure integrations, users, and system preferences.' },
    { target: '.collapsible-header', position: 'bottom', title: 'Sections', description: 'Expand each section to configure VMS, access control, intercoms, and more.' },
    { target: '.page-header-actions', position: 'bottom', title: 'Current Site', description: 'Shows which site you are configuring.' },
  ],
};
export default adminSettingsTutorial;
